import { useEffect, useState } from 'react';
import { Skp } from '../../model/Absensi';
import { RotateCcw, Star } from 'lucide-react';
import { fetchGetSkpsAll, fetchPatchSkp, RenderTableSkp } from '../../controller/dashboard/Skp';

// Minimal local stubs for modal and table components used in this page.
// These avoid runtime/TS errors if the actual implementations are not imported.
const AddSkpModal = ({ setShowAddModal, onPostState }: any) => null;
const DetailSkpModal = ({ employeeDetail, stateShowModal }: any) => null;

const EditSkpModal = ({ skpDetail, stateShowModal, onEditState }: { skpDetail: Skp | null; stateShowModal: (value: boolean) => void; onEditState: () => void }) => {
  const [nilaiSkp, setNilaiSkp] = useState(skpDetail?.nilai_skp ?? '');
  const [bulanTahun, setBulanTahun] = useState(skpDetail?.bulan_tahun ?? '');
  const [submitting, setSubmitting] = useState(false);

  const options = [
    { value: 4, label: 'Baik' },
    { value: 3, label: 'Butuh Perbaikan' },
    { value: 2, label: 'Kurang' },
    { value: 1, label: 'Sangat Kurang' },
  ];

  useEffect(() => {
    setNilaiSkp(skpDetail?.nilai_skp ?? '');
    setBulanTahun(skpDetail?.bulan_tahun ?? '');
  }, [skpDetail]);

  if (!skpDetail) return null;

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (!skpDetail?.id) return;

    setSubmitting(true);
    try {

      console.log(skpDetail.id, nilaiSkp);

      const res = await fetchPatchSkp({
        id: skpDetail.id,
        skp: Number(nilaiSkp) 
      });

      console.log(res);

      if (res?.status === 200 || res?.status === 201 || res?.status === 204) {
        onEditState();
        stateShowModal(false);
      } else {
        alert(res?.message || 'Gagal mengupdate SKP');
      }
    } catch (error) {
      console.error(error);
      alert('Gagal mengupdate SKP');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-800">Edit Nilai SKP</h3>
          <button type="button" onClick={() => stateShowModal(false)} className="text-gray-500 hover:text-gray-700">×</button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">Karyawan</label>
            <input
              value={skpDetail?.karyawan?.nama || '-'}
              disabled
              className="w-full rounded-lg border border-gray-300 bg-gray-100 px-3 py-2 text-sm"
            />
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium text-gray-700">Nilai SKP</label>
            <select value={nilaiSkp} onChange={(e) => { console.log(e.target.value); setNilaiSkp(e.target.value) }} className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm">
              <option value={0}>Pilih Nilai</option>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.value} - {option.label}
                </option>
              ))}
            </select>
          </div>
            {/* <input
              type="number"
              value={nilaiSkp}
              onChange={(e) => setNilaiSkp(e.target.value)}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
              required
            />
          </div> */}

          <div className="flex justify-end space-x-2 pt-2">
            <button type="button" onClick={() => stateShowModal(false)} className="rounded-lg border border-gray-300 px-4 py-2 text-sm text-gray-600 hover:bg-gray-100">Batal</button>
            <button type="submit" disabled={submitting} className="rounded-lg bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700 disabled:opacity-60">
              {submitting ? 'Menyimpan...' : 'Simpan'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default function DashboardDataSKP() {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [skpData, setSkpData] = useState<Skp[]>([]);
  const [selectedSkp, setSelectedSkp] = useState<Skp | null>(null);

  const today = new Date();
  const todayYear = String(today.getFullYear());
  const todayMonth = String(today.getMonth() + 1).padStart(2, '0');

  const [filterYear, setFilterYear] = useState<string>(todayYear);
  const [filterMonth, setFilterMonth] = useState<string>(todayMonth);
  const [filterDay, setFilterDay] = useState<string>('all');

  const getKaryawanName = (k: any) => {
    if (!k) return '';
    if (typeof k === 'string') return k;
    return k.nama || k.username || '';
  }

  const getDateParts = (value?: string) => {
    const raw = value ? value.split(' ')[0] : '';
    const parts = raw.split('-').filter(Boolean);
    const [y = '', m = '', d = ''] = parts;
    return {
      y,
      m: m ? String(m).padStart(2, '0') : '',
      d: d ? String(d).padStart(2, '0') : ''
    };
  };

  const filteredSkps = skpData.filter(skp => {
    const { y, m, d } = getDateParts(skp.bulan_tahun);
    if (filterYear !== 'all' && y !== filterYear) return false;
    if (filterMonth !== 'all' && m !== filterMonth.padStart(2, '0')) return false;
    if (filterDay !== 'all' && d && d !== filterDay.padStart(2, '0')) return false;

    return true;
  });

  const groupsMap: { [key: string]: Skp[] } = {};
  filteredSkps.forEach(skp => {
    const { y = '', m = '' } = getDateParts(skp.bulan_tahun);
    const key = `${y}-${m}`;
    if (!groupsMap[key]) groupsMap[key] = [];
    groupsMap[key].push(skp);
  });

  const groupKeys = Object.keys(groupsMap).sort((a, b) => b.localeCompare(a));
  const groups = groupKeys.map(key => ({
    key,
    rows: (groupsMap[key] || []).slice().sort((x, y) => (y.bulan_tahun || '').localeCompare(x.bulan_tahun || ''))
  }));

  const indexOfLastGroup = currentPage * itemsPerPage;
  const indexOfFirstGroup = indexOfLastGroup - itemsPerPage;
  const currentGroups = groups.slice(indexOfFirstGroup, indexOfLastGroup);
  const currentEmployees = currentGroups.flatMap(group => group.rows);
  const totalPages = itemsPerPage > 0 ? Math.ceil(groups.length / itemsPerPage) : 0;
  const pageNumbers = totalPages > 0 ? Array.from({ length: totalPages }, (_, i) => i + 1) : [];

  const initDataSkp = async () => { 
    setLoading(true);
    try {
      const res = await fetchGetSkpsAll();
      if (res.status === 200) { setSkpData(res.data); } 
      else { setSkpData([]); }
    } catch (error) {
      console.error(error);
      setSkpData([]);
    } finally {
      setLoading(false);
    }
  }

  const handleShowDetail = (skp: Skp) => {
    setSelectedSkp(skp);
    setShowDetailModal(true);
  };

  const handleEditDetail = (skp: Skp) => {
    setSelectedSkp(skp);
    setShowEditModal(true);
  };

  useEffect(() => {
    initDataSkp();
  }, []);

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
        <div className="max-w-8xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <Star className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Penilaian SKP</h1>
              </div>
            </div>
          </div>

          {/* Controls */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
              <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                <div className="flex items-center space-x-2">
                  <select value={filterYear} onChange={(e) => { setFilterYear(e.target.value); setCurrentPage(1); }} className="px-2 py-2 border rounded">
                    <option value="all">Semua Tahun</option>
                    {(() => {
                      const years = new Set<string>();
                      skpData.forEach(s => { const y = s.bulan_tahun ? s.bulan_tahun.split(' ')[0].split('-')[0] : ''; if (y) years.add(y); });
                      years.add(todayYear);
                      return Array.from(years).filter(Boolean).sort((a,b)=>b.localeCompare(a)).map((y) => (
                        <option key={y} value={y}>{y}</option>
                      ));
                    })()}
                  </select>
                  <select value={filterMonth} onChange={(e) => { setFilterMonth(e.target.value); setCurrentPage(1); }} className="px-2 py-2 border rounded">
                    <option value="all">Semua Bulan</option>
                    {Array.from({length:12}, (_,i) => ({v: String(i+1).padStart(2,'0'), label: new Date(0, i).toLocaleString('id-ID', { month: 'long' })})).map(m => (
                      <option key={m.v} value={m.v}>{m.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="flex space-x-3">
                <button
                  onClick={initDataSkp}
                  disabled={loading}
                  className="flex items-center px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors">
                  <RotateCcw className={`w-4 h-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
                  {loading ? 'Memuat...' : 'Muat Ulang'}
                </button>
                <button
                  onClick={() => { setFilterYear(todayYear); setFilterMonth(todayMonth); setFilterDay('all'); setCurrentPage(1); }}
                  className="flex items-center px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
                  Reset Filter
                </button>
              </div>
            </div>
          </div>

          {/* Employee Table */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Karyawan
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Nilai SKP
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Aksi
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {loading ? (
                    <tr>
                      <td colSpan={3} className="text-center py-4 text-gray-500">
                        Sedang Loading . . .
                      </td>
                    </tr>
                  ) : (
                    <RenderTableSkp data={filteredSkps} onOpenEdit={handleEditDetail} />
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="mt-6 flex items-center justify-between">
            <div className="text-sm text-gray-700">
              Menampilkan <span className="font-medium">{currentPage}</span> hingga{' '}
              <span className="font-medium">{groups.length}</span> dari{' '}
              <span className="font-medium">{groups.length}</span> kelompok tanggal
            </div>
            <div className="flex space-x-2">
              <button 
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(prev => prev - 1)}
              className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                Previous
              </button>
              
              { pageNumbers.map((page) =>( 
                <button 
                  key={page}
                  onClick={() => setCurrentPage(page)}
                  className={`px-3 py-1 rounded ${ currentPage === page ? "bg-blue-500 text-white" : "bg-gray-200" }`}>
                  {page}
                </button>
              ))}
              
              <button 
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(prev => prev + 1)}
                className="px-3 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                Next
              </button>
            </div>
          </div>
        </div>

        {/* Add Employee Modal */}
        {showAddModal && <AddSkpModal setShowAddModal={setShowAddModal} onPostState={initDataSkp} />}

        {/* Detail Employee Modal */}
        {showDetailModal && <DetailSkpModal employeeDetail={selectedSkp} stateShowModal={setShowDetailModal} />}

        {/* Detail Employee Modal */}
        {showEditModal && <EditSkpModal skpDetail={selectedSkp} stateShowModal={setShowEditModal} onEditState={initDataSkp}/>}
      </div>
    </>
  )
}
